import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import { Switch } from 'react-router-dom';
import { PrivateRoute } from 'slide-new-toolkit';
import CategoryForm from "./Form";
import CategoryList from "./List";
// import CategoryRemove from './Remove';

const mapStateToProps = state => ({
  productList: state.product.all,
});

class UBinfoShopProduct extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
  }

  render() {
    return (
      <Switch>
        <PrivateRoute exact path="/categories" component={CategoryList} />
        <PrivateRoute path="/categories/create" component={CategoryForm} />
        <PrivateRoute path="/categories/edit/:id" component={CategoryForm} />
        <PrivateRoute path="/categories/remove/:id" component={CategoryForm} />
      </Switch>
    );
  }
}

UBinfoShopProduct.propTypes = {};

UBinfoShopProduct.defaultProps = {
};

export default connect(mapStateToProps, {})(UBinfoShopProduct);




// WEBPACK FOOTER //
// ./src/containers/Categories/index.js